__turbopack_context__.v({
  "overlayTitle": "CollateralTeaser-module-scss-module__WQ0A-G__overlayTitle",
});
